import styled from '@emotion/styled';
import { IconChevronRight } from './Icons.js';

export const AnimatedChevronIcon = ({ isOpen }: { isOpen: boolean }) => (
  <AnimationWrapper className="starter-list-header-icon-button" isOpen={isOpen}>
    <IconChevronRight />
  </AnimationWrapper>
);

const AnimationWrapper = styled.div<{ isOpen: boolean }>`
  transition: transform 0.2s ease-in-out;
  transform: rotate(${({ isOpen }) => (isOpen ? '90deg' : '0deg')});
`;
